import { months } from "@/i18n/vueI18n";

export function getMonth(date = new Date()) {
  return months()[date.getMonth()];
}
